import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { categoryHierarcyContext } from "../context/CategoryHierarcyContext";
import { assortmentHierarcyContext } from "../context/AssortmentHierarcyContext";

import Textarea from "@mui/joy/Textarea";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import useLoginfo from "../../utils/useLoginfo";

const EditCategoryForm = () => {
  const {
    addUpdateCategoryHierarcyAction,
    getSingleCategoryHierarcyAction,
    catSingleRow,
  } = useContext(categoryHierarcyContext);

  const { fetchAssortmentHierarcyAction, assortmentHierarcy } = useContext(
    assortmentHierarcyContext
  );

  const history = useHistory()
  //OKTA
  const { tokenVal } = useLoginfo()

  const { catID } = useParams();

  useEffect(() => {

    fetchAssortmentHierarcyAction(tokenVal);
    getSingleCategoryHierarcyAction(catID, tokenVal);

  }, [tokenVal]);

  const [formData, setFormData] = useState({
    CASE: "EDIT",
    ASSORTMENT_ID: "",
    ASSORTMENT_SUB_DESC: "",
    ASSORTMENT_SUB: "",
    SORT_ORDER: "",
    ACTIVE: "",
    TYPE: "",
    CREATE_BY: "1",
    ASSORTMENT_ID_OLD: 0,
  });

  useEffect(() => {
    // console.log(catSingleRow);

    setFormData({
      ASSORTMENT_ID: catSingleRow[0]?.ASSORTMENT_ID,
      ASSORTMENT_SUB_DESC: catSingleRow[0]?.ASSORTMENT_SUB_DESC,
      ASSORTMENT_SUB: catSingleRow[0]?.ASSORTMENT_SUB,
      SORT_ORDER: catSingleRow[0]?.SORT_ORDER,
      ACTIVE: catSingleRow[0]?.ACTIVE,
      TYPE: catSingleRow[0]?.TYPE,
      CREATE_BY: "1",
      ASSORTMENT_ID_OLD: catSingleRow[0]?.ASSORTMENT_ID,
    });
  }, [catSingleRow]);

  //handle form change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [flag, setflag] = useState(false);
  //handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    //add Assortment_ID
    if (flag) {
      // console.log({ ...formData });
      addUpdateCategoryHierarcyAction({ ...formData }, tokenVal, history);
      // history.push("/category");
    }
  };

  //handle form cancel
  const handleCancel = (e) => {
    window.location.href = "/category";
  };

  return (
    <div>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{ marginLeft: "15px" }}
      >
        <Link underline="hover" color="inherit" href="/category">
          View Category
        </Link>
        <Link
          underline="hover"
          color="text.primary"
          href={`/edit-asssortment-category/${catID}`}
          aria-current="page"
        >
          Edit Category Form
        </Link>
      </Breadcrumbs>
      <h2 style={{ textAlign: "center" }}>Edit Category Form</h2>

      <form className="flex-container" onSubmit={handleSubmit}>
        <div style={{ marginLeft: "15px" }}>
          <div className="flex-container">
            <label className="">Assortment ID-Assortment Description</label>

            <TextField
              style={{ background: "rgb(247, 247, 248)" }}
              disabled={true}
              size="small"
              required={flag}
              name="ASSORTMENT_ID"
              value={formData.ASSORTMENT_ID}
              onChange={handleChange}
              className="depart"
              id="outlined-select-currency"
              select
            >
              {assortmentHierarcy.filter(i => i.ACTIVE == "Y")?.sort((a, b) => parseInt(a.ASSORTMENT_ID) - parseInt(b.ASSORTMENT_ID)).map((option) => (
                <MenuItem
                  key={option.ASSORTMENT_ID}
                  value={option.ASSORTMENT_ID}
                >
                  {option.ASSORTMENT_ID}-{option.ASSORTMENT_DESC}
                </MenuItem>
              ))}
            </TextField>
          </div>

          <div className="flex-container">
            <label className="descript">Category Description</label>

            <Textarea
              minRows={2}
              variant="outlined"
              required={flag}
              name="ASSORTMENT_SUB_DESC"
              value={formData.ASSORTMENT_SUB_DESC}
              onChange={handleChange}
              type="text"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Active</label>

            <TextField
              size="small"
              required={flag}
              name="ACTIVE"
              value={formData.ACTIVE}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">Sort Order</label>

            <TextField
              size="small"
              required={true}
              className="depart"
              name="SORT_ORDER"
              value={formData.SORT_ORDER}
              onChange={handleChange}
              type="text"
              id="outlined-lead"
            />
          </div>

          <div
            style={{
              marginTop: "50px",
              display: "flex",
              marginBottom: "50px",
            }}
          >
            <div className="save-btn">
              <Button
                type="submit"
                variant="contained"
                color="success"
                onClick={(e) => setflag(true)}
                size="large"
              >
                <span className="cat-radio">Save</span>
              </Button>
            </div>
            <div>
              <Button
                className=""
                variant="contained"
                color="error"
                onClick={handleCancel}
                size="large"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditCategoryForm;
